export const SET_INPUT = 'login/SET_INPUT';
export const LOGIN_START = 'login/LOGIN_START';
export const LOGIN_COMPLETED = 'login/LOGIN_COMPLETED';
export const LOGIN_FAILED = 'login/LOGIN_FAILED';


